import React from "react";
import PropTypes from "prop-types";

const ResponseMessage = ({ message, isError }) => {
  const className = "m-response-message";
  const errorClass = isError ? `${className}--error` : "";
  return (
    <div className={`${className} ${errorClass}`}>
      <p>{message}</p>
    </div>
  );
};

ResponseMessage.propTypes = {
  message: PropTypes.string.isRequired,
  isError: PropTypes.bool,
};

export default ResponseMessage;
